import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import queryString from 'query-string';

import BaseFilter, { FilterTypeEnum } from 'components/base/BaseFilter';
import { MessageBackendChannel, MessageChannel } from 'config/CustomEnums';

import { ArrayStringData } from 'utils';

function Filter({ backAction = () => {} }) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search);
  const searchMessageChannel = parsedSearch['message_channel'] || '';

  const [messageChannel, setMessageChannel] = useState(
    ArrayStringData(searchMessageChannel),
  );

  const content = [
    {
      title: 'Message channel',
      data: [
        {
          name: MessageChannel.all,
          pk: MessageBackendChannel.all,
        },
        {
          name: MessageChannel.allWhatsapp,
          pk: MessageBackendChannel.allWhatsapp,
        },
        {
          name: MessageChannel.allWechat,
          pk: MessageBackendChannel.allWechat,
        },
        {
          name: MessageChannel.push,
          pk: MessageBackendChannel.push,
        },
        {
          name: MessageChannel.email,
          pk: MessageBackendChannel.email,
        },
        {
          name: MessageChannel.sms,
          pk: MessageBackendChannel.sms,
        },
        {
          name: MessageChannel.whatsapp,
          pk: MessageBackendChannel.whatsapp,
        },
        {
          name: MessageChannel.wechat,
          pk: MessageBackendChannel.wechat,
        },
        {
          name: MessageChannel.inbox,
          pk: MessageBackendChannel.inbox,
        },
      ],
      value: messageChannel,
      setValue: setMessageChannel,
      component: FilterTypeEnum.choice,
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default Filter;
